import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { first, map } from 'rxjs/operators';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { ApiService } from 'src/app/api.service';
import { CookieTovpil } from 'src/app/shared/models/CookieTovpil';
import { ResponseFile } from 'src/app/shared/models/ResponseFile';
import { FVIIEconRealWrp } from 'src/app/shared/vo/FVIIEconRealWrp';
import { TovpilCrudService } from 'src/app/utils/tovpil-crud-service';
import { TovpilFilesService } from 'src/app/utils/tovpil-files.service';
import { TovpilLanguageService } from 'src/app/utils/tovpil-language.service';
import { UrlBuilderService } from 'src/app/utils/tovpil-url-builder.service';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { UserPreferencesService } from 'src/app/utils/user-preferences.service';

@Component({
  selector: 'app-fvii-econreal',
  templateUrl: './fvii-econreal.component.html',
  styleUrls: ['./fvii-econreal.component.scss'],
  providers: [MessageService, ConfirmationService, TovpilLanguageService]
})
export class FviiEconrealComponent implements OnInit {

  /** USER PREFERENCES */
  globalUserPreferences: CookieTovpil = {};
  globalUserDataForm: FormGroup;

  /** Query Params */
  dataParent: any = {};
  storeId: string;
  period: string;
  year: string;
  selectedCurrency: string;

  columns: any = [
  ];

  colsFilter = [
    "storeId",
    "strName",
    "lastBal",
    "currentBal",
    "inventBal",
    "accRecAmt",
    "accPayAmt",
    "econReality",
    "currencyId",
    "exchRate",
    "toAmount"
  ];

  data: FVIIEconRealWrp[];

  /** COMPONENT */
  languages: any[];
  currencies: any[] = [];
  periods: any[] = [];

  /** PIPES */
  datePipe: DatePipe = new DatePipe('en-US');

  /** LABELS */
  translations: Record<string, string> = {};

  /** COMPONENT OVERLAY */
  blocked: boolean = true;
  responseFile?: ResponseFile;

  // Endpoints
  endPointGetValidPeriods = "getValidPeriods";


  /**
   * This constructor function initializes various services and variables used in the component, and also
   * checks for authentication based on the token and device parameters passed in the URL.
   * @param {MessageService} messageService - This parameter is of type MessageService and is used for
   * displaying messages to the user. It is likely used to show success or error messages during certain
   * operations.
   * @param {ConfirmationService} confirmationService - The `confirmationService` is a service that
   * provides methods for displaying confirmation dialogs to the user. It is used to prompt the user for
   * confirmation before performing certain actions.
   * @param {ApiService} apiService - An instance of the ApiService class, which is responsible for
   * making API requests and handling responses.
   * @param {ActivatedRoute} route - The `route` parameter is an instance of the `ActivatedRoute` class,
   * which is used to access the current route's information. It provides access to the route's
   * parameters, query parameters, and other related data. In this code snippet, the `route` parameter is
   * used to subscribe to the
   * @param {AuthenticationService} authenticationService - This parameter is used to authenticate the
   * user and manage user authentication-related tasks, such as logging in, logging out, and retrieving
   * the current user's information.
   * @param {TovpilFilesService} filesService - The `filesService` parameter is an instance of the
   * `TovpilFilesService` class. It is used to handle file-related operations, such as uploading and
   * downloading files.
   * @param {TovpilCrudService} tovpilCrudService - The `tovpilCrudService` parameter is an instance of
   * the `TovpilCrudService` class. It is used to perform CRUD (Create, Read, Update, Delete) operations
   * on data in the application.
   * @param {FormBuilder} fb - The `fb` parameter is an instance of the `FormBuilder` class. It is used
   * to create instances of `FormGroup` and `FormControl` for building reactive forms in Angular.
   */
  constructor(
    private messageService: MessageService,
    private apiService: ApiService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private authenticationService: AuthenticationService,
    private tovpilCrudService: TovpilCrudService,
    private filesService: TovpilFilesService,
    private tovpilUtils: TovpilUtilsService,
    private router: Router,
    private userPreferencesService: UserPreferencesService,
    private translationService: TovpilLanguageService,
    private urlBuilderService: UrlBuilderService
  ) {
    this.createDataForm();
    this.initConfigs();

    // SE OBTUVIERON PREFERENCIAS EN INIT CONFIG
    const user = this.globalUserPreferences.preferences;
    const currentUser = this.authenticationService.currentUserValue;
    const securitySelected = this.globalUserPreferences;
    const navigation = this.router.getCurrentNavigation();
    this.route.queryParams.subscribe(params => {
      // Asigna los valores de queryParams a las propiedades de dataParent
      this.dataParent.storeId = params.storeId;
      this.dataParent.period = params.currPeriod;
      this.dataParent.year = params.currYear;
    });

    if (securitySelected?.tokenProfile && user && user.device === "2") {
      this.autenthicateByZuul('generalaccess', 'hY6Mn_4hn9vDrWrh6');
    } else {
      //this.globalUserPreferences.preferences.currentUser = currentUser;
    }

  }

  /**
    * The function initializes form groups for configuration and data, and updates the configuration form
    * with query parameters from the route.
    */
  async initConfigs() {
    this.globalUserPreferences = await this.userPreferencesService.getSantovTovpilCookie() || null;
    console.debug(this.globalUserPreferences);
  }

  /**
    * The function `createDataForm` in TypeScript initializes a form group with various form controls and
    * default values, as well as setting some controls as disabled.
    */
  createDataForm() {
    this.globalUserDataForm = this.fb.group({
      selectedCoordination: new FormControl(null),
      selectedPeriod: new FormControl(null),
      selectedCurrency: new FormControl(null)
    });
  }

  /**
   * The ngOnInit function initializes the component by setting the currentUser property to the current
   * user value from the authentication service and calling the getSecurity function.
   */
  ngOnInit(): void {
    const currentUser = this.authenticationService.currentUserValue;
    if (this.dataParent) {
      this.storeId = this.dataParent.storeId || this.globalUserPreferences.preferences.storeSelected.id;
      this.period = this.dataParent.period || this.globalUserPreferences.preferences.selPeriod;
      this.year = this.dataParent.year || this.globalUserPreferences.preferences.selYear;
    }
    else {
      this.storeId = this.globalUserPreferences.preferences.storeSelected.id;
      this.period = this.globalUserPreferences.preferences.selPeriod;
      this.year = this.globalUserPreferences.preferences.selYear;
    }
    this.getSecurity();
  }

  /**
   * The function `autenthicateByZuul` authenticates a user by calling the `login` method of the
   * `authenticationService` and performs additional actions based on the response.
   * @param {string} user - The `user` parameter is a string that represents the username or user
   * identifier for authentication.
   * @param {string} password - The password parameter is a string that represents the user's password.
   */
  autenthicateByZuul(user: string, password: string) {
    this.authenticationService.login(user, password)
      .pipe(first())
      .subscribe(
        data => {
          if (data.code == 'R-0200') {
            this.getSecurity();
          } else {

          }
        },
        error => {

        });
  }

  /**
   * The function `getSecurity()` retrieves security data and performs additional actions if the data is
   * not already available.
   */
  async getSecurity() {
    const securityControl = this.globalUserPreferences || null;

    // ACTUALIZAMOS SEGURIDAD NUEVAMENTE Y TENTATIVAMENTE SE PUEDE ELIMINAR ESTOS BLOQUES
    if (!securityControl) {
      const tokenProfile = this.globalUserPreferences?.tokenProfile || null;
      const data = await this.apiService.findSecurityById({ id: tokenProfile });
      this.globalUserPreferences = data;
    }

    await this.getTranslatedLabels();
    await this.getInitData();
  }

  /**
   * The function `getTranslatedLabels` is an asynchronous function that retrieves translated labels from
   * a translation service and sets them in the `translations` variable, and then calls another function
   * .
   */
  async getTranslatedLabels() {
    const language = this.globalUserPreferences?.preferences?.language || null;
    const region = this.globalUserPreferences?.preferences?.region || null;

    try {
      await this.translationService.getTranslatedLabels(language, region);
      this.translations = this.translationService.getLabels();
      this.columns = this.tovpilUtils.translateCols(this.columns, this.translations);
    } catch (error) {
      console.error("An error occurred while getting translated labels:", error);
    }
  }

  /**
   * The  function fetches valid periods from a service and assigns them to a list, then
   * selects a default period and returns a boolean indicating success.
   * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
   * true), and false if there is an error or the data retrieval is not successful.
   */
  /**
  * The  function fetches valid periods from a service and assigns them to a list, then
  * selects a default period and returns a boolean indicating success.
  * @returns a boolean value. It returns true if the data retrieval is successful (data.success is
  * true), and false if there is an error or the data retrieval is not successful.
  */
  async getValidPeriods(language: string) {
    try {
      const data = await this.tovpilCrudService.fetch(this.endPointGetValidPeriods, language);
      if (!data.success) {
        throw new Error("Error en periods");
      }

      const lstPeriod = data.data || []; // Handle empty data array
      // const selPeriod = this.globalUserPreferences?.preferences?.periodSelected ?? null;
      const selYear = this.year || this.globalUserPreferences.preferences.selYear || null;
      const selPeriod = this.period || this.globalUserPreferences.preferences.selPeriod || null;

      const selectedPeriod = selYear
        ? lstPeriod.find(period => period.year === selYear && period.period === selPeriod)
        : lstPeriod[0]; // Default to first period if no selection or year missing

      this.periods = lstPeriod;

      this.globalUserDataForm.patchValue({
        selectedPeriod: selectedPeriod
      });
    } catch (error) {
      this.handleError(error);
    }
  }


  async getListCurrencies(storeId: string, language: string) {
    if (!storeId)
      throw new Error("No storeId");

    if (!language)
      throw new Error("No language");

    try {
      const response = await this.apiService.getListCurrencyByStoreId({
        storeId: storeId,
        language: language
      });

      if (response.length <= 0)
        throw new Error("Currencies not found");

      this.currencies = response;
      this.globalUserDataForm.patchValue({
        selectedCurrency: response[0]
      });
    } catch (error) {
      this.handleError(error);
    }
  }


  /**
   * The function asynchronously fetches store data and updates the global user data
   * form with the retrieved information.
   * @returns The function returns a boolean value (`true` or `false`) based on the
   * success of fetching store data and updating the `selectedCoordination` value in the
   * `globalUserDataForm`. If the store data is successfully fetched, it returns `true`. If there is an
   * error during the process, it returns `false`.
   */
  async getCoordination(storeId: string) {
    if (!storeId)
      throw new Error("No storeId");
    try {
      const response = await this.apiService.getStoreById({
        storeId: storeId
      });
      if (response == null)
        throw new Error("Store not found");

      this.globalUserDataForm.patchValue({
        selectedCoordination: response.storeId + " " + response.descri
      });

    } catch (error) {
      this.handleError(error);
    }
  }

  /**
   * The `getInitData` function fetches price list data, selected price data, and exchange rate data,
   * and then updates the form with the fetched data.
   */
  async getInitData() {
    const language = this.globalUserPreferences.preferences.language;
    const storeId = this.storeId;
    try {
      await this.getValidPeriods(language);
      await this.getListCurrencies(storeId, language);
      await this.getCoordination(storeId);
      await this.loadData(storeId);
    } catch (error) {
      this.handleError(error);
    }
  }


  /**
   * The `loadData` function is an asynchronous function that loads data from an API and displays a
   * message based on the validity of the form data.
   * @returns nothing.
   */
  async loadData(storeId: string) {
    const year = this.globalUserDataForm.get('selectedPeriod').value.year || "2025";
    const period = this.globalUserDataForm.get('selectedPeriod').value.period || "1";
    const language = this.globalUserPreferences.preferences.language || "es";
    const currency = this.globalUserDataForm.get('selectedCurrency').value.valueId || "MXN";
    this.blocked = true;

    if (this.currencies.length == 1) {
      this.columns = [
        { header: "lbl_id", field: "storeId", type: "string" },
        { header: "lbl_description", field: "strName", type: "string" },
        { header: "lbl_previous_balance", field: "lastBal", type: "number" },
        { header: "lbl_current_balance", field: "currentBal", type: "number", info: "(1)" },
        { header: "lbl_inventory", field: "inventBal", type: "number", info: "(2)" },
        { header: "lbl_receivable_accounting", field: "accRecAmt", type: "number", info: "(3)" },
        { header: "lbl_payable_accounting", field: "accPayAmt", type: "number", info: "(4)" },
        { header: "lbl_economic_reality", field: "econReality", type: "number", info: "(1) + (2) + (3) - (4)" },
      ];
      this.columns = this.tovpilUtils.translateCols(this.columns, this.translations);

      this.colsFilter = [
        "storeId",
        "strName",
        "lastBal",
        "currentBal",
        "inventBal",
        "accRecAmt",
        "accPayAmt",
        "econReality"
      ];
    }
    else {
      this.columns = [
        { header: "lbl_id", field: "storeId", type: "string" },
        { header: "lbl_description", field: "strName", type: "string" },
        { header: "lbl_previous_balance", field: "lastBal", type: "number" },
        { header: "lbl_current_balance", field: "currentBal", type: "number", info: "(1)" },
        { header: "lbl_inventory", field: "inventBal", type: "number", info: "(2)" },
        { header: "lbl_receivable_accounting", field: "accRecAmt", type: "number", info: "(3)" },
        { header: "lbl_payable_accounting", field: "accPayAmt", type: "number", info: "(4)" },
        { header: "lbl_economic_reality", field: "econReality", type: "number", info: "(1) + (2) + (3) - (4)" },
        { header: "lbl_currency", field: "currencyId", type: "string" },
        { header: "lbl_exchange_rate", field: "exchRate", type: "string" },
        { header: "lbl_total", field: "toAmount", type: "number", info: ` (${this.globalUserDataForm.get('selectedCurrency').value.valueId})` }
      ];
      this.columns = this.tovpilUtils.translateCols(this.columns, this.translations);
      this.colsFilter = [
        "storeId",
        "strName",
        "lastBal",
        "currentBal",
        "inventBal",
        "accRecAmt",
        "accPayAmt",
        "econReality",
        "currencyId",
        "exchRate",
        "toAmount"
      ];
    }
    try {
      const response = await this.apiService.lstFVIIEconReal({
        storeId: storeId,
        year: year,
        period: period,
        language: language,
        currency: currency
      });

      if (response.length == 0)
        throw new TypeError("No data found");

      const data = response.map(e => ({
        ...e,
        econReality: (e.currentBal + e.inventBal + e.accRecAmt - e.accPayAmt).toFixed(2),
        currentBal: e.currentBal?.toFixed(2),
        inventBal: e.inventBal?.toFixed(2),
        accRecAmt: e.accRecAmt?.toFixed(2),
        accPayAmt: e.accPayAmt?.toFixed(2),
        toAmount: e.toAmount?.toFixed(2),
      }));

      this.data = data;

    } catch (error) {
      if (error instanceof TypeError) {
        this.handleWarn(error.message);
      } else {
        console.error(error);
        this.handleError(error);
      }

      this.data = [];
    }
    this.blocked = false;
  }


  async reload() {
    const storeId = this.globalUserPreferences.preferences.storeId || this.storeId;
    await this.loadData(storeId);
  }


  /**
   * The function "capitalizeLastElement" takes a string as input and returns the same string with the
   * last element capitalized.
   * @param {string} str - The parameter `str` is a string that represents the input string.
   * @returns the result of calling the `capitalizeLastElement` method of the `tovpilCrudService` object
   * with the `str` parameter.
   */
  capitalizeLastElement(str: string): string {
    return this.tovpilCrudService.capitalizeLastElement(str);
  }

  /**
   * The function `getNestedValue` retrieves a nested value from an object using a specified field.
   * @param {any} obj - The `obj` parameter is an object from which you want to retrieve a nested value.
   * @param {string} field - The `field` parameter is a string that represents the path to a nested value
   * in the `obj` object.
   * @returns The `getNestedValue` function is returning the value of the nested field in the given
   * object.
   */
  getNestedValue(obj: any, field: string): any {
    let value = this.tovpilCrudService.getNestedValue(obj, field);
    return value;
  }

  /**
   * The `exportExcel()` function exports data to an Excel file if the data is not null and not empty,
   * otherwise it displays an error message.
   */
  exportExcel() {
    const storeId = this.storeId;
    let title = "FVII";

    if (this.data == null || this.data.length <= 0) {
      this.messageService.add({
        severity: 'warn',
        summary: this.translations.lbl_no_records_found,
        life: 3000
      });
    } else {
      const filteredJSON = this.data.map((order) => {
        return {
          [this.translations.lbl_id]: order.storeId || '',
          [this.translations.lbl_description]: order.strName || '',
          [this.translations.lbl_previous_balance]: order.lastBal || 0.0,
          [this.translations.lbl_current_balance + " (1)"]: order.currentBal || 0.0,
          [this.translations.lbl_inventory + " (2)"]: order.inventBal || 0.0,
          [this.translations.lbl_receivable_accounting + " (3)"]: order.accRecAmt || 0.0,
          [this.translations.lbl_payable_accounting + " (4)"]: order.accPayAmt || 0.0,
          [this.translations.lbl_economic_reality + " (1) + (2) + (3) - (4)"]: order.econReality || 0.0,
          [this.translations.lbl_exchange_rate]: order.exchRate || '',
          [this.translations.lbl_total]: order.toAmount || 0.0
        };
      });
      this.filesService.tovpilExportXLSX(filteredJSON, `${title}_${storeId}_`);
    }
  }

  /**
   * The function `exportPdf` generates a PDF file based on provided data and column filters.
   * @param {any[]} _data - The `_data` parameter is an array containing the data that will be used to
   * generate the PDF. It is expected to be an array of objects where each object represents a row of
   * data to be included in the PDF.
   * @param {any[]} _colsFilter - The `_colsFilter` parameter is an array containing objects with
   * properties `name` and `value`. It is used to filter and map the data in the `_data` array to
   * generate a PDF. Each object in `_colsFilter` specifies a column name and the corresponding value to
   * extract from the data
   * @param {string} _name - The `_name` parameter in the `exportPdf` function is a string that
   * represents the name of the PDF file that will be generated. It is used as a reference to name the
   * PDF file when it is exported.
   */
  exportPdf(_data: any[], _colsFilter: any[], _name: string) {
    if (_data === null || _data.length < 1) {
      //this.handleError('FII List', 'Hubo un problema al procesar la información del PDF. Por favor, recargue la página e inténtelo nuevamente más tarde.');
    } else {
      const filteredJSON = _data.map((item) => {
        const dynamicColumns = _colsFilter.map((col) => ({
          [col.name]: item ?
            this.tovpilCrudService.getNestedValueDynamic(item, col.value) || 'S/N' : 'S/N'
        }));
        return Object.assign({}, ...dynamicColumns);
      });
      const keysArray = filteredJSON.map((item) => Object.keys(item));
      const valuesArray = filteredJSON.map((item) => Object.values(item));
      this.filesService.tovpilExportPDF(keysArray[0], valuesArray, _name);
    }
  }

  /**
   * The `onChangeUserPreferences` function updates user preferences including language, period, and
   * currency, and then updates the user preferences entity, cookie, and triggers a reload.
   */
  async onChangeUserPreferences() {

    // console.debug("FiiList() onChangeUserPreferences")
    await this.refreshPreferences();

    // RECARGA
    this.initConfigs();
  }

  /* The above TypeScript code is updating properties of a user object, specifically setting the
      languageId, currencyId, periodYear, and periodMonth based on the provided values or null if not
      provided. It also updates the periodSelected property with the provided period value. Finally,
      it updates a cookie named "userPreferences" with the updated globalUserPreferences object using
      a cookie service. */
  async refreshPreferences() {
    // SOLO SE ACTUALIZA LA COOKIE
    let language = this.globalUserDataForm.get('selectedLanguage').value?.valueId || null;
    let currency = this.globalUserDataForm.get('selectedCurrency').value?.valueId || null;
    let selYear = this.globalUserDataForm.get('selectedPeriod').value?.year || null;
    let selPeriod = this.globalUserDataForm.get('selectedPeriod').value?.period || null;

    // ACTUALIZAMOS PROPIEDADES DE USUARIO
    this.userPreferencesService.updateTovpilCookie(
      null, // _levelId
      null, //_userId
      null, //_storeId
      null, //_id
      language || null, //_language
      currency || null, //_selCurrency
      null, //_coordinationId
      null, //_coordinationStack
      selYear, //_selYear
      selPeriod, //_selPeriod
      null, //_device
      null, //_storeSelected
      null, //_periodSelected
      null //_stores
    );
  }


  /**
   * The goBack function closes the current window.
   */
  async goBack() {

    try {
      let queryParams = {
        module: 'treasurer',
        view: 'FVIIEconReal',
      };

      let navigationExtras: NavigationExtras = {
        queryParams: queryParams
      };

      // Navegas a la ruta deseada con los parámetros de consulta
      window.close();
      this.router.navigate(['/commons/lcSelector'], navigationExtras);
    } catch (error) {
      console.error("An error occurred while navigating:", error);
    }
  }

  handleError(message: string) {
    console.error("An error occurred");
    this.messageService.add({
      severity: 'error',
      summary: 'Error',
      detail: message,
      life: 5000
    });
  }

  handleWarn(message: string) {
    this.messageService.add({
      severity: 'warn',
      summary: 'Warn',
      detail: message,
      life: 5000
    });
  }

  async dwnFVIIEconRealXls() {
    this.blocked = true;
    try {
       const year = this.globalUserDataForm.get('selectedPeriod').value.year || "2025";
        const period = this.globalUserDataForm.get('selectedPeriod').value.period || "1";
        const language = this.globalUserPreferences.preferences.language || "es";
        const currency = this.globalUserDataForm.get('selectedCurrency').value.valueId || "MXN";

      // FALTAN LOS DATOS DEL REQUEST
      const response = await this.apiService.dwnFVIIEconRealXls({
        storeId: this.storeId,
        year: year,
        period: period,
        language: language,
        currency: currency
      });
          this.responseFile = response;
          const source = `data:application/octet-stream;base64,${this.responseFile.base64File}`;
          const link = document.createElement("a");
          link.href = source;
          link.download = this.responseFile.nameFile
          link.click();
    } catch (error) {
      console.error("An error occurred while exporting excel:", error);
      this.messageService.add({ severity: 'warn', summary: 'Error', detail: `Error: ${this.translations.lbl_translation} ${this.translations.lbl_language}: ${error}` });
    } finally {
      this.blocked = false;
    }

     this.blocked = false;
  }
}

